import React from "react";
import { Link } from "react-router-dom";

//import components
import SidebarContent from "./SidebarContent";

//import images
import SM_LOGO from 'assets/images/logo/logo-small.png'
import LG_LOGO from 'assets/images/logo/logo-large.png'
// import logo from "../../assets/images/logo/logo-small.png";
// import logoLightPng from "../../assets/images/logo/logo-large.png";
// import logoLightSvg from "../../assets/images/logo-light.svg";
// import logoDark from "../../assets/images/logo/logo-large.png";

const Sidebar = (props: any) => {
  return (
    <React.Fragment>
      <div className="vertical-menu" data-sidebar="dark">
        <div className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={SM_LOGO} alt="" height="22" />
            </span>
            <span className="logo-lg mx-auto">
              <img src={LG_LOGO} alt="" height="41" />
            </span>
          </Link>

          {/* <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={LG_LOGO} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={LG_LOGO} alt="" height="19" />
            </span>
          </Link> */}
        </div>
        <div data-simplebar className="h-100">
          <SidebarContent /> 
        </div>
        {/* <div className="sidebar-background"></div> */}
      </div>
    </React.Fragment>
  );
};

export default Sidebar;